// src/pages/PaymentTestPage.js
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../services/firebase/config';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../services/firebase/config';
import { ArrowLeft } from 'lucide-react';

const PaymentTestPage = () => {
    const [user] = useAuthState(auth);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [debugResponse, setDebugResponse] = useState(null); // Debug için yanıtı saklayalım
  
    const handlePayment = async () => {
      if (!user) return navigate('/login');
  
      try {
        setLoading(true);
        setError(null);
        
        const orderId = `ORD${Date.now()}`;
        console.log('Creating order:', orderId);
        
        // Create order in Firestore
        await setDoc(doc(db, 'users', user.email, 'orders', orderId), {
          userId: user.email,
          status: 'pending',
          amount: 20,
          createdAt: serverTimestamp()
        });
  
        console.log('Order created in Firestore');
  
        // Request payment token from backend
        const paymentData = {
          user: user.uid,
          amount: '20',
          email: user.email,
          userName: user.displayName || 'Test User',
          address: 'Test Address',
          phone: '05555555555'
        };
  
        console.log('Sending payment request:', paymentData);
  
        const response = await axios.post(
          'http://127.0.0.1:5001/zq-portfoy/us-central1/api/payment/paytr', 
          paymentData
        );
        
        console.log('PayTR response:', response.data);
        setDebugResponse(response.data); // Debug için yanıtı saklayalım
  
        // Create and submit form to PayTR
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = 'https://www.paytr.com/odeme';
        form.target = '_self';
  
        // Add all fields from response
        Object.entries(response.data).forEach(([key, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = value;
          form.appendChild(input);
        });
  
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
  
      } catch (err) {
        console.error('Payment error:', err);
        setError(err.response?.data?.error || 'Ödeme işlemi başarısız oldu');
      } finally {
        setLoading(false);
      }
    };
  
    return (
      <div className="max-w-2xl mx-auto p-4">
        <button onClick={() => navigate(-1)} className="flex items-center text-gray-600 mb-6">
          <ArrowLeft className="w-4 h-4 mr-2" />
          <span>Geri</span>
        </button>
  
        <div className="bg-white rounded-lg shadow p-6">
          <h1 className="text-2xl font-bold mb-4">PayTR Test Ödemesi</h1>
          
          <div className="mb-6">
            <p className="text-gray-600">Test ödeme tutarı: 20 TL</p>
            <p className="text-sm text-gray-500">Bu bir PayTR test ödemesidir</p>
            {user && (
              <p className="text-sm text-gray-500 mt-2">
                Kullanıcı: {user.email}
              </p>
            )}
          </div>
  
          {error && (
            <div className="bg-red-50 text-red-600 p-4 rounded mb-4">
              {error}
            </div>
          )}
  
          <button
            onClick={handlePayment}
            disabled={loading || !user}
            className="w-full bg-blue-600 text-white p-3 rounded-lg font-medium hover:bg-blue-700 disabled:opacity-50"
          >
            {loading ? 'İşleniyor...' : 'PayTR ile Öde'}
          </button>
  
          {!user && (
            <p className="text-sm text-red-500 mt-2">
              Ödeme yapmak için giriş yapmalısınız
            </p>
          )}
  
          {/* Debug bilgisi */}
          {debugResponse && (
            <div className="mt-4 p-4 bg-gray-50 rounded">
              <h3 className="text-sm font-medium mb-2">Debug Response:</h3>
              <pre className="text-xs overflow-auto">
                {JSON.stringify(debugResponse, null, 2)}
              </pre>
            </div>
          )}
        </div>
      </div>
    );
  };
  
  export default PaymentTestPage;